










































// check this out: https://blog.logrocket.com/how-to-write-a-vue-js-app-completely-in-typescript/

import Vue from 'vue'
import Page from '@/components/layouts/Page.vue'
import PageSection from '@/components/layouts/PageSection.vue'
// import { store } from '@/state'
import ClientsList from './components/ClientsList.vue'
import CreateClient from './components/CreateClient.vue'
import ClientsCreatedList from './components/ClientsCreatedList.vue'

/**
 * State for new clients just created
 */
interface NewClient {
  name: string;
  id: string;
}

export default Vue.extend({
  name: 'ClientsPage',

  components: {
    Page,
    PageSection,
    ClientsList,
    CreateClient,
    ClientsCreatedList,
  },
  data: () => ({
    createNewClientMode: false,
    newClients: [] as NewClient[],
  }),
  methods: {
    createNewClientClicked() {
      this.createNewClientMode = true
    },
    onCreateNewClientCancelled() {
      this.createNewClientMode = false
    },
    onCreateNewClientFinished() {
      this.createNewClientMode = false
    },
    onNewClientCreated(newClient: NewClient) {
      this.newClients.push(newClient)
    },
    onNewClientAlertDismissed(index: number) {
      this.newClients.splice(index, 1)
    },

  },
})

